import UserInvitationContainer from './invite/UserInvitationContainer';
import UserComponent from './UserComponent';
import UserListContainer from './UserListContainer';
import UserInvitationListContainer from '../UserInvitationList/UserInvitationListContainer';

const userRoutes = [
  {
    path: '/accounts/:aid/users/invite',
    component: UserInvitationContainer,
  },
  {
    path: '/accounts/:aid/users/invitations',
    component: UserInvitationListContainer,
  },
  {
    path: '/accounts/:aid/users',
    component: UserListContainer,
    exact: true,
  },
  {
    path: '/accounts/:aid/users/:id',
    component: UserComponent,
  },
];

export default userRoutes;
